export default __webpack_public_path__ + "static/media/IconUser.77227c0e.svg";